import _regeneratorRuntime from "/usr/local/dench/git-cf/denchcorp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _toConsumableArray from "/usr/local/dench/git-cf/denchcorp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/usr/local/dench/git-cf/denchcorp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/usr/local/dench/git-cf/denchcorp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/local/dench/git-cf/denchcorp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var CacheService = /*#__PURE__*/function () {
  function CacheService() {
    _classCallCheck(this, CacheService);
  }

  _createClass(CacheService, [{
    key: "cacheRequest",
    value: function () {
      var _cacheRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cacheName, apiPromise) {
        var append,
            noCache,
            updateCache,
            responseType,
            cacheGroup,
            cache,
            hasCache,
            response,
            options,
            res,
            jsonResponse,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                append = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
                noCache = _args.length > 3 && _args[3] !== undefined ? _args[3] : false;
                updateCache = _args.length > 4 && _args[4] !== undefined ? _args[4] : true;
                responseType = _args.length > 5 && _args[5] !== undefined ? _args[5] : 'json';
                cacheGroup = _args.length > 6 && _args[6] !== undefined ? _args[6] : 'apiCache';
                cacheName = '/' + cacheName;
                _context.next = 8;
                return caches.open(cacheGroup);

              case 8:
                cache = _context.sent;

                if (!(noCache === false)) {
                  _context.next = 15;
                  break;
                }

                _context.next = 12;
                return caches.match(cacheName);

              case 12:
                _context.t0 = _context.sent;
                _context.next = 16;
                break;

              case 15:
                _context.t0 = false;

              case 16:
                hasCache = _context.t0;

                if (!hasCache) {
                  _context.next = 29;
                  break;
                }

                if (!(responseType !== 'json')) {
                  _context.next = 24;
                  break;
                }

                _context.next = 21;
                return hasCache;

              case 21:
                response = _context.sent;
                _context.next = 27;
                break;

              case 24:
                _context.next = 26;
                return hasCache[responseType]();

              case 26:
                response = _context.sent;

              case 27:
                _context.next = 35;
                break;

              case 29:
                _context.t1 = apiPromise;

                if (!_context.t1) {
                  _context.next = 34;
                  break;
                }

                _context.next = 33;
                return apiPromise();

              case 33:
                _context.t1 = _context.sent;

              case 34:
                response = _context.t1;

              case 35:
                options = {
                  headers: {
                    'Content-Type': 'application/json'
                  }
                };

                if (!append) {
                  _context.next = 45;
                  break;
                }

                _context.next = 39;
                return cache.match(cacheName);

              case 39:
                res = _context.sent;

                if (!res) {
                  _context.next = 45;
                  break;
                }

                _context.next = 43;
                return res.json();

              case 43:
                res = _context.sent;
                response['content'] = [].concat(_toConsumableArray(res.content), _toConsumableArray(response['content']));

              case 45:
                if (updateCache === true && (!hasCache || append)) {
                  jsonResponse = new Response(JSON.stringify(response), options);
                  cache.put(cacheName, responseType === 'json' ? jsonResponse : response.clone());
                }

                return _context.abrupt("return", response);

              case 47:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function cacheRequest(_x, _x2) {
        return _cacheRequest.apply(this, arguments);
      }

      return cacheRequest;
    }()
  }]);

  return CacheService;
}();

export default new CacheService();